// Convert flag object to string name for consistency
const getFlagName = flag => (typeof flag === "string" ? flag : flag.NAME);

/**
 * Check if a user has a specific feature flag
 * @param {Object} lenndFlags - The lenndFlags object from Redux store
 * @param {string|Object} requiredFlag - The required flag (can be string or flag object)
 * @returns {boolean} - Whether the flag is enabled
 */
export const hasFlag = (lenndFlags, requiredFlag) => {
  if (!lenndFlags) return false;
  const flagName = getFlagName(requiredFlag);
  return !!lenndFlags[flagName];
};

/**
 * Check if any of the required flags are enabled
 * @param {Object} lenndFlags - The lenndFlags object from Redux store
 * @param {Array<string|Object>} requiredFlags - Array of required flags
 * @returns {boolean} - Whether any of the flags are enabled
 */
export const hasAnyFlag = (lenndFlags, requiredFlags) => {
  if (!lenndFlags || !requiredFlags.length) return false;
  return requiredFlags.some(flag => hasFlag(lenndFlags, flag));
};

/**
 * Check if all of the required flags are enabled
 * @param {Object} lenndFlags - The lenndFlags object from Redux store
 * @param {Array<string|Object>} requiredFlags - Array of required flags
 * @returns {boolean} - Whether all flags are enabled
 */
export const hasAllFlags = (lenndFlags, requiredFlags) => {
  if (!lenndFlags || !requiredFlags.length) return false;
  return requiredFlags.every(flag => hasFlag(lenndFlags, flag));
};
